import { render } from "./serial.vue?vue&type=template&id=3dfcc373&scoped=true"
import script from "./serial.vue?vue&type=script&lang=js"
export * from "./serial.vue?vue&type=script&lang=js"

import "./serial.vue?vue&type=style&index=0&id=3dfcc373&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfcc373"]])

export default __exports__